<ng-container *ngIf="members.length < 4;else multi">
  <a-avatar *ngFor="let member of members" [user]="member"></a-avatar>
</ng-container>
<ng-template #multi>
  <a-multiple-avatars [users]="members" [showDetails]="false"></a-multiple-avatars>
</ng-template>
